export enum PackageManagerTypes {
  Npm = 'npm',
  Go = 'golang',
  Gem = 'gem',
  Maven = 'maven',
  Pypi = 'pypi',
  Pnpm = 'pnpm',
}
